import { render, staticRenderFns } from "./SideBarMarketing.vue?vue&type=template&id=62a9529d&scoped=true&"
import script from "./SideBarMarketing.vue?vue&type=script&lang=js&"
export * from "./SideBarMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a9529d",
  null
  
)

export default component.exports